/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SmsProcessingListconfig } from './smsProcessingListconfig';


export interface SmsMessageBody { 
    id: number;
    content?: string;
    countryCode?: string;
    country?: string;
    destination?: string;
    dton: number;
    dnpi: number;
    originator?: string;
    oton: number;
    onpi: number;
    messageId?: string;
    userDataHeader?: string;
    extendedParameters?: string;
    encoding?: string;
    userName?: string;
    referenceNumber?: string;
    requestSource?: string;
    deliveryTime?: Date;
    sendingChannelOption: number;
    smsChannel: number;
    smSRouteName?: string;
    senderId?: string;
    creatorId?: string;
    shouldPerfromMNP: boolean;
    shouldPerformDND: boolean;
    shouldPerformDuplicationCheck: boolean;
    mnc?: string;
    mcc?: string;
    scheduleDateTime?: Date;
    expiryDateTime?: Date;
    priority: number;
    smsRoute?: string;
    smsProcessingListconfig?: SmsProcessingListconfig;
    moTransactionMessageId?: string;
}
